import { useEffect } from "react";
import { useSelector } from "react-redux";
import Layout from "../../Utils/Navbar/navbar-layout-component";
import Footer from "../../Utils/Footer/footer-component";
import ImageComponent from '../../Utils/Image/image-component';
import NavLink from "../../Utils/NavLink/navlink-component";
import { getRefundStrings } from '../../Public/refund-data';
import { renderParagraphs } from "../../Utils/Content/content-section-component";
import ContentSection from "../../Utils/Content/content-section-component";

function Refund() {
    const systemData = useSelector((s) => s.systemData || {});
    const { language, dir, businessInfo = {} } = systemData;
    const { phone, email, website } = businessInfo;
    const r = getRefundStrings(language);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div>
            <Layout seo={r.seo}>
                <div dir={dir} className="min-h-full w-full">

                    <section className="relative w-full h-[40vh] lg:h-[50vh] overflow-hidden">
                        <img
                            src={r.heroSection.image}
                            alt={r.title}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className={`absolute inset-0 z-10 ${r.heroSection.overlay}`} />
                        <div className="absolute inset-0 z-20 flex items-end justify-center lg:justify-start px-6 md:px-10 lg:px-24 pb-10">
                            <div className="text-center lg:text-left">
                                <h1 className="text-4xl md:text-6xl lg:text-7xl text-white font-bold ">
                                    {r.title}
                                </h1>
                                <p className="mt-3 text-white text-base md:text-lg lg:text-2xl font-light">
                                    {r.effectiveDateLabel}: {r.effectiveDate}
                                </p>
                            </div>
                        </div>
                    </section>

                    <main>
                        <div className="bg-white dark:bg-black rounded-3xl py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-10 shadow-sm w-full mt-[-20px] relative z-20">
                            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

                                <div className="lg:col-span-7">
                                    <div className="prose dark:prose-invert lg:prose-lg max-w-none leading-relaxed">
                                        {r.introParagraphs.map((para, i) => (
                                            <div key={i} className={i === 0 ? "text-lg lg:text-xl font-medium text-gray-800 dark:text-gray-100 mb-4" : "mb-4"}>
                                                {renderParagraphs(para)}
                                            </div>
                                        ))}

                                        {r.sections.map((sec) => {
                                            const paras = typeof sec.paragraphs === 'function' ? sec.paragraphs(businessInfo) : sec.paragraphs;
                                            return (
                                                <div key={sec.id} className="mb-8">
                                                    <h2 className="mt-10 text-2xl lg:text-3xl font-semibold  text-gray-900 dark:text-white">
                                                        <strong>{sec.number}.</strong> {sec.heading}
                                                    </h2>
                                                    {paras.map((pText, idx) => (
                                                        <div key={idx} className="mt-4">
                                                            {renderParagraphs(pText)}
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        })}

                                        <h2 className="mt-16 text-2xl lg:text-3xl font-semibold  text-gray-900 dark:text-white">
                                            {r.contactTitle}
                                        </h2>
                                        <p className="mb-6">{typeof r.contactIntro === 'function' ? r.contactIntro(businessInfo) : r.contactIntro}</p>
                                    </div>
                                </div>

                                <div className="lg:col-span-5 sticky top-32 space-y-6">
                                    <div className="hidden lg:block overflow-hidden rounded-3xl shadow-xl">
                                        <ImageComponent
                                            src={r.heroSection.image}
                                            alt="refund policy"
                                            className="w-full h-full object-cover aspect-[4/5]"
                                        />
                                    </div>
                                    <div className="flex justify-center">
                                        <NavLink
                                            href="/landing"
                                            showUnderline={false}
                                            className="bg-black text-white px-12 py-4 rounded-full font-bold hover:scale-105 transition-transform w-full text-center"
                                        >
                                            {r.conversionSection.buttonText}
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    <ContentSection
                        title={r.conversionSection.title}
                        backgroundImage={r.conversionSection.bgImage}
                        backgroundColor={r.conversionSection.bgColor}
                        className="mt-20 !rounded-t-[3rem]"
                    >
                        <div className="flex flex-col items-center gap-6 text-center">
                            <p className="text-lg opacity-80 max-w-xl">
                                {r.conversionSection.subtitle}
                            </p>
                            <div className="flex flex-wrap justify-center gap-12 mt-4">
                                <div className="flex flex-col items-center">
                                    <span className="text-xs uppercase tracking-widest opacity-50 mb-2">Email</span>
                                    <NavLink href={`mailto:${email}`} className="font-bold text-xl">{email}</NavLink>
                                </div>
                                <div className="flex flex-col items-center">
                                    <span className="text-xs uppercase tracking-widest opacity-50 mb-2">Phone</span>
                                    <NavLink href={`tel:${phone}`} className="font-bold text-xl">{phone}</NavLink>
                                </div>
                                <div className="flex flex-col items-center">
                                    <span className="text-xs uppercase tracking-widest opacity-50 mb-2">Website</span>
                                    <NavLink href={website} target="_blank" className="font-bold text-xl">{website}</NavLink>
                                </div>
                            </div>
                        </div>
                    </ContentSection>
                </div>
            </Layout>
            <Footer />
        </div>
    );
}

export default Refund;
